// import Golf6 from "../images/cars-big/golf6.jpg";
// import AudiA1 from "../images/cars-big/audia1.jpg";
// import Toyota from "../images/cars-big/toyotacamry.jpg";
// import Bmw320 from "../images/cars-big/bmw320.jpg";
// import Benz from "../images/cars-big/benz.jpg";
// import Passat from "../images/cars-big/passatcc.jpg";

import allion from "../images/cars-big/allion.png"
import wagonR from "../images/cars-big/wagonR.png"
import prius from "../images/cars-big/prius.png"
import aqua from "../images/cars-big/auqa.png"
import nv200 from "../images/cars-big/nv200.png"
import kdh from "../images/cars-big/kdh.png"



export const CAR_DATA = [
  [
    {
      name: "Suzuki Wagon R",
      price: "6000",
      img: wagonR,
      model: "Wagon R",
      mark: "Suzuki",
      year: "2015",
      doors: "4/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Petrol",
    },
  ],
  [
    {
      name: "Toyota Allion",
      price: "10,000",
      img: allion,
      model: "Allion",
      mark: "Toyota",
      year: "2012",
      doors: "4/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Petrol",
    },
  ],
  [
    {
      name: "Toyota Aqua",
      price: "7000",
      img: aqua,
      model: "Aqua",
      mark: "Toyota",
      year: "2013",
      doors: "4/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Petrol",
    },
  ],
  [
    {
      name: "Toyota Prius",
      price: "8000",
      img: prius,
      model: "Prius",
      mark: "Toyota",
      year: "2013",
      doors: "4/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Petrol",
    },
  ],
  [
    {
      name: "Nissan NV200",
      price: "8000",
      img: nv200,
      model: "NV200",
      mark: "Nissan",
      year: "2012",
      doors: "4/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Petrol",
    },
  ],
  [
    {
      name: "Toyota KDH",
      price: "12,000",
      img: kdh,
      model: "KDH",
      mark: "Toyota",
      year: "2012",
      doors: "4/5",
      air: "Yes",
      transmission: "Automatic",
      fuel: "Petrol",
    },
  ],
];
